// extracted by mini-css-extract-plugin
export default {"popover":"VtuV2s"};